import PropTypes from 'prop-types';
import {SelectEntity} from '@ozgene/gp5.components.select-entity';
import {findMetricUnits} from 'Consumables/service/ConsumableService';

export default function SelectMetricUnit(props) {
  const {value, id, placeholder, name, onChange, label, ...restProps} = props;

  return (
    <SelectEntity
      getEntities={findMetricUnits}
      value={value}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
      {...restProps}
    />
  );
}

SelectMetricUnit.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string,
    unit: PropTypes.string,
  }),

  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

SelectMetricUnit.defaultProps = {
  value: null,
  id: null,
  name: null,
  label: 'Metric Unit',
  placeholder: '',
};
